/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-04-26 17:12:58
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-06-08 10:06:45
 * @FilePath: \experience-pc\src\util\cookie.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cookies from 'js-cookie'

// token
export function getToken() {
  return Cookies.get('admin_token')
}

export function setToken(token) {
  return Cookies.set('admin_token', token)
}

export function getUserInfo(){
  return Cookies.get('userInfo')
}

export function setUserInfo(user) {
  return Cookies.set('userInfo', user)
}

// Name
export function setName(name) {
  return Cookies.set('name', name)
}

export function getName() {
  return Cookies.get('name')
}



// user id
export function setId(user_id) {
  return Cookies.set('user_id', user_id)
}

export function getId() {
  return Cookies.get('user_id')
}

// user id
export function setGroupId(group_id) {
  return Cookies.set('group_id', group_id)
}

export function getGroupId() {
  return Cookies.get('group_id')
}

// 顶部菜单刷新 index
export function setNavActiveIndex(index) {
  return Cookies.set('activeIndex', index)
}

export function getNavActiveIndex() {
  return Cookies.get('activeIndex')
}

// 清除所有cookie
export function removeAll() {
  Cookies.remove('activeIndex')
  Cookies.remove('user_id')
  Cookies.remove('group_id')
  Cookies.remove('name')
  Cookies.remove('admin_token')
  Cookies.remove('userInfo')
}



// WEBPACK FOOTER //
// ./src/util/cookie.js